<template>
  <div class="CodeMirror" v-if="isShowDom">
    <div class="top_bg" :style="{backgroundColor:cmOptions.theme === 'idea'?'#f5f5f5':'#313335'}">
      <el-row>
        <el-col :span="24">
          <el-form ref="form" :inline="true" :style="{color:cmOptions.theme === 'idea'?'#999':'#999'}">
            <el-form-item label="语言">
              <el-select :value="language" placeholder="请选择" @change="onLangChange" size="mini" style="width:100px">
                <el-option v-for="item in arr1" :key="item.id" :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="主题">
              <el-select v-model="cmOptions.theme" placeholder="请选择" size="mini" @change="onThemeChange" style="width:100px">
                <el-option v-for="item in themes" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="字号">
              <el-select v-model="size" placeholder="请选择" size="mini" @change="onFontSize" style="width:100px">
                <el-option v-for="item in sizeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <!-- <el-form-item label="代码提示">
              <el-switch v-model="showHint" active-color="#13ce66" inactive-color="grey">
              </el-switch>
            </el-form-item> -->
            <el-form-item :label="!isFullScreen?'全屏':'退出全屏'" style="float:right;color:#999;">
              <div @click="handleFullScreen1" style="cursor: pointer;" class="el-icon-full-screen"></div>
            </el-form-item>
          </el-form>
        </el-col>

      </el-row>

    </div>

    <codemirror v-model="code1" :options="cmOptions" @ready="onCmReady" ref="myEditor" :style="{ fontSize: size1 }">
    </codemirror>
  </div>
</template>
<script>

import { codemirror } from "vue-codemirror";
//import "codemirror/theme/mdn-like.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/idea.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！
import "codemirror/theme/darcula.css"; // 这里引入的是主题样式，根据设置的theme的主题引入，一定要引入！！

require("codemirror/mode/python/python"); // 这里引入的模式的js，根据设置的mode引入，一定要引入！！

import 'codemirror/mode/clike/clike.js' // 主题的关键字颜色，一定要引入！！！

//代码补全提示

import "codemirror/addon/hint/show-hint.css";
import "codemirror/addon/hint/show-hint.js";

//选中行背景
import "codemirror/addon/selection/active-line"; //光标行背景高亮,styleActiveLine 设置为true

//代码折叠
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/addon/fold/foldcode";
import "codemirror/addon/fold/foldgutter";
import "codemirror/addon/fold/brace-fold";
import "codemirror/addon/fold/comment-fold";
import "codemirror/addon/fold/markdown-fold";
import "codemirror/addon/fold/xml-fold";
import "codemirror/addon/fold/indent-fold";

//括号自动闭合
import "codemirror/addon/edit/matchbrackets";
import "codemirror/addon/edit/closebrackets";

//搜索功能
import "codemirror/addon/scroll/annotatescrollbar.js";
import "codemirror/addon/search/matchesonscrollbar.js";
import "codemirror/addon/search/match-highlighter.js";
import "codemirror/addon/search/jump-to-line.js";

import "codemirror/addon/dialog/dialog.js";
import "codemirror/addon/dialog/dialog.css";
import "codemirror/addon/search/searchcursor.js";
import "codemirror/addon/search/search.js";
//终端显示
import "xterm/css/xterm.css";
import { Terminal } from "xterm";
import { FitAddon } from "xterm-addon-fit";
import { AttachAddon } from "xterm-addon-attach";
//代码高亮solarizedlight
// import "prismjs/themes/prism-dark.css";

import { getEditorRemark } from "@/api/educational";
export default {
  name: 'CodeMirrorGame',
  components: {
    codemirror
  },
  props: ['code', 'language', 'arr1', 'changelanguage'],
  data() {
    return {

      isShowDom: true,
      size1: '16px',
      size: '2',
      sizeList: [
        { label: '14px', value: '1' },
        { label: '16px', value: '2' },
        { label: '18px', value: '3' },
        { label: '20px', value: '4' },
        { label: '22px', value: '5' },
        { label: '24px', value: '6' },
        { label: '26px', value: '7' },
        { label: '28px', value: '8' },
      ],
      languages1: [
        {
          id: '0',
          label: 'c'
        },
        {
          id: '1',
          label: 'c++'
        },
        {
          id: '2',
          label: 'Python3'
        },
      ],
      languageChange: '',
      code1: '',
      cmOptions: {
        hintOptions: {
          completeSingle: false,
          hint: this.handleShowHint
        },
        // codemirror options
        tabSize: 4,
        indentUnit: 4,
        mode: 'text/x-c++src',
        theme: 'darcula',
        height: "auto",
        lint: true,
        lineNumbers: true,
        line: true,
        dragDrop: true,
        //readOnly:'nocursor', 只读模式
        //括号自动闭合
        matchBrackets: true,
        autoCloseBrackets: true,

        styleActiveLine: false, // 显示选中行的样式
        extraKeys: {
          Ctrl: "autocomplete",
          Tab: (cm) => {
            if (cm.somethingSelected()) {      // 存在文本选择
              cm.indentSelection('add');    // 正向缩进文本
            } else {                    // 无文本选择
              cm.replaceSelection(Array(cm.getOption("indentUnit") + 1).join(" "), "end", "+input");  // 光标处插入 indentUnit 个空格
            }
          }
        },
        autofocus: true,
        // 代码折叠
        foldGutter: true,
        // gutters: ['CodeMirror-linenumbers', 'CodeMirror-foldgutter'],
        gutters: [
          "CodeMirror-lint-markers",
          "CodeMirror-linenumbers",
          "CodeMirror-foldgutter",
        ],
        // 选中文本自动高亮，及高亮方式
        styleSelectedText: true,
        // lineWrapping: true,
        highlightSelectionMatches: { showToken: /\w/, annotateScrollbar: true },

      },
      themes: [
        { label: '暗', value: 'darcula' },
        { label: '亮', value: 'idea' },
      ],

      //自定义搜索关键词
      hint_words: [],
      keylist: [],
      showHint: false,
      showAiError: false,
      isFullScreen: false
    }
  },
  computed: {
    codemirror() {
      return this.$refs.myEditor.codemirror;
    },
  },
  watch: {
    'code'(newVal) {
      this.code1 = newVal
      console.log(this.code1, '新代码')
    },
    'language'(newVal) {
      console.log(newVal, 121212);
      this.languageChange = this.language;
      console.log(this.language, 12122);
      console.log(this.changelanguage, 12122);
      console.log(this.arr1, 12122);
      //读取代码提示文件
      if (this.language === '1') {
        getEditorRemark({
          subject_code: '4'
        }).then((res) => {
          console.log(res, 48545452);
          this.hint_words = res.editorRemarkList;

        })
      } else if (this.language === '2') {
        getEditorRemark({
          subject_code: '3'
        }).then((res) => {
          console.log(res, 48545452);
          this.hint_words = res.editorRemarkList;

        })
      }
    },
    'languageChange'(newVal) {
      console.log(newVal, 12122);
      this.$emit('language2', newVal)    // 刚求完直接$emit

    },
    'code1'(newVal) {
      console.log(newVal, '新代码11111111')

      if (newVal == ' ') {
        console.log('新输入代码为空');
        this.keylist = [];
      }


      this.$emit('cdata', newVal)
    }



  },
  created() {
    this.code1 = this.code
  },

  mounted() {
    if (sessionStorage.getItem('sizeFont') === null) {
      this.size = '2'
      this.size1 = '16px'
    } else {
      this.size = sessionStorage.getItem('sizeFont')
      this.sizeList.forEach(sizeItem => {
        if (sizeItem.value === this.size) {
          this.size1 = sizeItem.label
        }
      })
    }

    getEditorRemark({
      subject_code: '4'
    }).then((res) => {
      this.hint_words = res.editorRemarkList;

    })
    this.initTerm()
  },
  methods: {
    //终端显示
    initTerm() {
      const term = new Terminal({
        fontSize: 18,
        cursorBlink: true,
        rows: parseInt(
          (document.documentElement.clientHeight * 0.25 - this.console_offset) /
          18
        ), //行数
        theme: {
          foreground: "white", //字体
          background: "#2b2b2b", //背景色
          cursor: "white",
        },
      });
      const attachAddon = new AttachAddon(this.socket);
      const fitAddon = new FitAddon();
      term.loadAddon(attachAddon);
      term.loadAddon(fitAddon);

      term.open(document.getElementById("xterm"));

      fitAddon.fit();
      term.focus();
      this.term = term;
    },
    handleShowHint(cmInstance) {
      let cursor = cmInstance.getCursor();
      let token = cmInstance.getTokenAt(cursor);
      this.keylist = [];
      for (let i = 0; i < this.hint_words.length; i++) {
        if (this.hint_words[i].text.toLowerCase().indexOf(token.string.toLowerCase()) == 0) {
          this.keylist.push(this.hint_words[i]);
        }
      }
      return {
        list: this.keylist,
        from: {
          ch: token.start,
          line: cursor.line
        },
        to: {
          ch: token.end,
          line: cursor.line
        }
      };
    },
    onCmReady(cm) {
      // 这里的 cm 对象就是 codemirror 对象，等于 this.$refs.myCm.codemirror
      cm.on("inputRead", (cm, obj) => {
        if (obj.text && obj.text.length > 0) {
          let c = obj.text[0].charAt(obj.text[0].length - 1);
          if ((c >= "a" && c <= "z") || (c >= "A" && c <= "Z") || c == "<") {

            if (this.showHint) {
              cm.showHint();
            }

          }
        }
      });
    },


    onLangChange(newVal) {
      this.$emit('changeLang', newVal)
      if (newVal === '0') {
        this.hint_words = [];
      } else if (newVal === '1') {
        getEditorRemark({
          subject_code: '4'
        }).then((res) => {
          console.log(res, 48545452);
          this.hint_words = res.editorRemarkList;

        })
      } else if (newVal === '2') {
        getEditorRemark({
          subject_code: '3'
        }).then((res) => {
          console.log(res, 48545452);
          this.hint_words = res.editorRemarkList;

        })
      }
      console.log(newVal, 456)
      if (newVal === '0') {
        this.cmOptions.mode = 'text/x-csrc'
      } else if (newVal === '1') {
        this.cmOptions.mode = 'text/x-c++src'
      } else {
        this.cmOptions.mode = 'python'
      }



    },
    onThemeChange(val) {
      this.cmOptions.theme = val
    },
    onFontSize(val) {
      sessionStorage.setItem('sizeFont', val)
      this.sizeList.forEach(sizeItem => {
        if (sizeItem.value === val) {
          this.size1 = sizeItem.label
        }
      })
      this.$refs.myEditor.refresh()
    },
    handleFullScreen1() {
      this.isFullScreen = !this.isFullScreen
      this.$emit('handleFullScreen1')
    }
  }
}



</script>

<style lang="less" scoped></style>

<style scoped>
/deep/ .el-form-item {
  margin-bottom: 0px;
}

/deep/ .el-form-item__label {
  color: inherit;
}

/deep/ .el-icon-s-claim:before {
  color: inherit;
}

/deep/ .el-icon-monitor:before {
  color: inherit;
}

/deep/ .CodeMirror-scroll {
  height: 100%;
  padding-bottom: 0px;
  margin-bottom: 0px;
  overflow-y: scroll;
}

/deep/ .top_bg {
  background-color: #313335;
  padding: 10px;
}
/deep/ .CodeMirror {
  width: 100%;
  height: 100% !important;
  overflow-x: hidden;
}

/deep/ .cm-comment {
  font-style: initial !important;
}
/deep/ .cm-def {
  font-style: initial !important;
}
</style>
